import { isMobile } from "../../js/global-scripts";

const mapNav = document.querySelectorAll('.map-nav-select')

mapNav.forEach(nav => {
    nav.addEventListener('click', navClickHandler)
})

function navClickHandler(e) {
    const link = e.target.closest('.i-select__item')
    if (!link) return
    e.preventDefault()

    const container = link.closest('.map-nav-wrapper')
    const {markerId} = link.dataset

    if (!link.classList.contains('is-active')) {
        [...container.querySelectorAll('.card-contacts')].forEach(el => {
            el.classList.remove('is-active')
            if (el.dataset.markerId === markerId) {
                el.classList.add('is-active')
            }
        })
    }

    PubSub.publish(CHANNEL_NAMES.navContacts, {container, id: markerId})
}

function updMapMargin(map, el, accessor) {
    if (accessor) accessor.remove()

    if (window.matchMedia("(max-width: 1199px)").matches) return

    return map.margin.addArea({
        top: el.offsetTop,
        left: el.offsetLeft,
        width: el.clientWidth,
        height: el.clientHeight
    })
}

function setActiveMarker(map, id) {
    if (map.geoObjects.getLength() <= 1) return
    map.geoObjects.each(el => {
        if (el.options.get('id') === id) {
            el.options.set('iconImageHref', 'img/map-marker-green.svg')
            return
        }
        el.options.set('iconImageHref', 'img/map-marker-brown.svg')
    })
}
try {
    ymaps.ready(init);
} catch (err) {}

function init() {
    const mapContainers = [...document.querySelectorAll('.contacts-map-container')]
    const simpleMaps = [...document.querySelectorAll('.simple-map')]

    mapContainers.forEach(map => {
        const contactsBlock = map.closest('.contacts-grid, .contacts-content')

        const markersMap = new Map()

        const myMap = new ymaps.Map(map, {
            center: [55.755819, 37.617644],
            zoom: 16,
            controls: []
        }, {
            autoFitToViewport: 'always'
        });
        myMap.behaviors.disable('scrollZoom')
        if (isMobile.any()) {
            myMap.behaviors.disable('drag')
        }

        const balloonMap = contactsBlock.querySelector('.contacts-grid__map-balloon')
        if (balloonMap) {
            let accessor = updMapMargin(myMap, balloonMap)
            myMap.events.add('sizechange', () => {
                accessor = updMapMargin(myMap, balloonMap, accessor)
            })

            myMap.panTo(myMap.getCenter(), {useMapMargin: true})
        }

        ;[...contactsBlock.querySelectorAll('.card-contacts')].forEach(card => {
            const id = card.dataset.markerId
            const coordinatesRaw = card.dataset.coordinates
            const coordinates = coordinatesRaw && (JSON.parse(coordinatesRaw))
            const hint = card.dataset.hint

            if (!Array.isArray(coordinates) && !coordinates.length) return

            markersMap.set(id, coordinates)

            let placeMark = new ymaps.Placemark(coordinates, {
                hintContent: hint
            }, {
                id: id,
                iconLayout: 'default#image',
                iconImageHref: 'img/map-marker-brown.svg',
                iconImageSize: [49, 63],
                iconImageOffset: [-24.5, -63],
                iconShadow: true,
                iconShadowImageHref: 'img/map-marker-shadow.png',
                iconShadowImageSize: [67, 81],
                iconShadowImageOffset: [-34.5, -68],
            })

            placeMark.events
                .add('click', function (e) {
                    contactsBlock.querySelector(`.i-select__item[data-marker-id='${id}']`)?.dispatchEvent(new Event('click', {bubbles: true}))
                    setActiveMarker(myMap, id)
                })

            myMap.geoObjects.add(placeMark)

        })

        switch (markersMap.size) {
            case 0:
                break
            case 1:
                myMap.panTo(markersMap.entries().next().value[1], {useMapMargin: true, flying: false, safe: true})
                break
            default:
                const id = contactsBlock.querySelector('.card-contacts.is-active').dataset.markerId
                const center = markersMap.get(id)
                if (center) {
                    myMap.panTo(center, {useMapMargin: true, flying: false, safe: true})
                    setActiveMarker(myMap, id)
                }
                break
        }

        PubSub.subscribe(CHANNEL_NAMES.navContacts, ({container, id, ...data}) => {
            if (contactsBlock === container) {
                const center = markersMap.get(id)
                if (center) {
                    setActiveMarker(myMap, id)
                    myMap.panTo(center, {useMapMargin: true, flying: false, safe: true})
                        .then(() => {
                            myMap.setZoom(17, {useMapMargin: true, duration: 0})
                        })
                }
            }
        })

    })

    simpleMaps.forEach(map => {
        const coordinatesRaw = map.dataset.coordinates
        const coordinates = coordinatesRaw && (JSON.parse(coordinatesRaw))

        const center = [55.755819, 37.617644]
        const myMap = new ymaps.Map(map, {
            center: coordinates || center,
            zoom: 16,
            controls: [],
        }, {
            autoFitToViewport: 'always'
        })
        myMap.behaviors.disable('scrollZoom')
        if (isMobile.any()) {
            myMap.behaviors.disable('drag')
        }

        if (coordinates) {
            const placeMark = new ymaps.Placemark(coordinates, {
                // hintContent: ''
            }, {
                iconLayout: 'default#image',
                iconImageHref: 'img/map-marker-brown.svg',
                iconImageSize: [49, 63],
                iconImageOffset: [-24.5, -63],
                iconShadow: true,
                iconShadowImageHref: 'img/map-marker-shadow.png',
                iconShadowImageSize: [67, 81],
                iconShadowImageOffset: [-34.5, -68],
            })

            myMap.geoObjects.add(placeMark)
        }
    })
}